import { Route } from '@/views/vSearch/route-VUE_APP_PROJ.js'

export default Route
